export default "__VITE_ASSET__1FtdZC5o__"